export default "__VITE_ASSET__Ccq5b_we__"